<template>
  <validation-observer ref="validator" v-slot="{ errors }" tag="div" class="container application">
    <div class="term-desc" />
    <h2
      @click.prevent="test"
    >
      유의사항
    </h2>

    <h3 class="page-title sub">차량 이용 안내</h3>
    <div class="content">
      <small>
        - 일부 차종 혹은 한정특가 차종의 경우 쏘카플랜의 운영 계획에 따라 계약연장이 불가할 수 있습니다.<br>
        - 계약의 중도해지 및 조기반납을 희망하시는 경우 계약해지를 신청한 이후 영업일 기준 2일 이후에 반납이 가능합니다.<br>
        - 쏘카플랜 차량은 하이패스 단말기가 설치되어 있지만, 하이패스 카드는 제공하지 않으니 필요시 직접 구매 및 장착 후 이용이 가능합니다. 단, 미납금이 발생하는 경우 건당 3,000원의 처리수수료가 추가 부과됩니다.<br>
        - 약정 주행거리란 '계약기간 내에 이용이 가능한 주행거리' 로 1개월 기준 1,500km가 제공됩니다. 차량 반납 시 약정 주행거리를 초과한 경우 추가비용이 청구될 수 있습니다.<br>
      </small>
      <small v-if="isElectric">
        - 쏘카플랜은 전기차 충전 카드를 별도로 제공하지 않으며, 충전 비용은 계약자 부담입니다.<br>
        - 전기차는 연식 또는 주행환경에 따라 공식 안내되는 주행 가능 거리보다 적을 수 있습니다.<br>
        - 차량 반납 시 충전량은 최초 인수 시 확인된 충전량 만큼 충전해 주셔야 하며, 차량 인수 시와 동일한 상태(복구가 필요 없는 양호한 상태)로 반납하여야 합니다.<br>
        - 충전량이 부족하여 주행이 불가한 상태로 반납 시, 차고지 이동에 필요한 실비가 청구될 수 있습니다.<br>
      </small>
      <small v-else>
        - 차량 반납 시 연료량은 최초 차량 인수 시 확인된 연료량만큼 채워주셔야 하며, 차량 인수 시와 동일한 상태(복구가 필요없는 양호한 상태)로 반납하여야 합니다.<br>
      </small>
      <small>
        - 쏘카플랜 차량의 인수 반납은 모두 비대면으로 이루어집니다.<br>
      </small>
    </div>

    <h3 class="page-title sub">계약 취소 수수료/ 중도 해지 위약금 안내</h3>
    <div class="content">
      <small v-if="isMonthlySubscribe">
        대여 시작일 이전 계약을 해지하실 경우 취소 수수료<br>
        - 대여 시작일까지 8일 이상 남은 경우: 할인 전 월 대여요금의 10%<br>
        - 대여 시작일까지 7일 이하 남은 경우: 할인 전 월 대여요금의 30%<br>
        대여 시작일 이후(당일 포함) 계약을 해지하실 경우 위약금<br>
        - 별도의 위약금이 발생하지 않으며 해당 이용월까지 쏘카플랜을 계속 이용할 수 있습니다.<br>
        - 잔여 기간에 대한 환불은 불가합니다.
      </small>
      <small v-if="!isMonthlySubscribe">
        대여 시작일 이전 계약을 해지하실 경우 취소 수수료<br>
        - 대여 시작일까지 8일 이상 남은 경우: 할인 전 월 대여요금의 10%<br>
        - 대여 시작일까지 7일 이하 남은 경우: 할인 전 월 대여요금의 30%<br>
        대여 시작일 이후(당일 포함) 계약을 해지하실 경우 위약금<br>
        - (기준 월 대여료 * 12 / 365 * (약정 기간 - 실제 사용기간) * 위약금률) + (월 약정 할인 금액 * 할인 적용 개월)<br>
        기준 월 대여료: 할인 전 기준 대여요금<br>
        위약금률<br>
        - 계약 기간 2개월 미만 : 30%<br>
        - 계약 기간 2개월 이상 : 20%<br>
        월 약정 할인 금액 : 계약해지 전월까지 적용된 약정 할인 금액<br>
      </small>
    </div>

    <h3 class="page-title sub">프로모션 및 특별 혜택</h3>
    <div class="content">
      <small>- 프로모션 및 특별 혜택은 최초 계약 시에만 적용되며, 추가 계약 연장 및 양도 계약자에게는 적용되지 않습니다.</small><br>
      <small v-if="!isMonthlySubscribe || (isMonthlySubscribe && isMonthlySubscribeCouponTime)">- 셰어링 24시간 무료 쿠폰은 계약자 본인이 사용하거나, 타인에게 양도할 수 있습니다. 단, 쏘카 계정에 쿠폰코드를 등록한 뒤에는 변경 또는 양도가 불가합니다.<br></small>
      <small>- 프로모션 및 특별 혜택은 당사 사정에 따라 별도 고지 없이 변경 또는 종료될 수 있습니다.</small>
    </div>

    <ul class="list-member-terms">
      <li>
        <div class="term-head form-agree">
          <input
            id="agreeAllTerms"
            v-model="agreeAllTerms"
            type="checkbox"
            value=""
            name="agreeAllTerms"
            class="form-agree-input"
            @change="agreeAllTermsChange"
          >
          <label class="form-agree-label" for="agreeAllTerms">전체 내용에 동의합니다.</label>
        </div>
      </li>

      <li>
        <div class="term-head form-agree" :class="{ error: hasError(errors, '서비스 유의사항 동의')}">
          <validator rules="required" name="서비스 유의사항 동의">
            <input
              id="agreeService"
              v-model="agreeTerms.agreeService"
              name="agreeService"
              class="form-agree-input"
              type="checkbox"
              value=""
              @change="agreeTermsChange({ agreeService: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreeService">
              <em class="text-brand">(필수) </em><span style="font-weight: normal">서비스 유의사항 동의</span>
            </label>
          </validator>
        </div>
      </li>

      <li>
        <div class="term-head form-agree" :class="{ error: hasError(errors, '쏘카플랜 자동차 대여약관 동의')}">
          <validator rules="required" name="쏘카플랜 자동차 대여약관 동의">
            <input
              id="agreeCarSharing"
              v-model="agreeTerms.agreeCarSharing"
              name="agreeCarSharing"
              class="form-agree-input"
              type="checkbox"
              value=""
              @change="agreeTermsChange({ agreeCarSharing: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreeCarSharing">
              <em class="text-brand">(필수) </em><button @click="moveToCarSharing">쏘카플랜 자동차 대여약관 동의</button>
            </label>
          </validator>
        </div>
      </li>

      <li>
        <div class="term-head form-agree" :class="{ error: hasError(errors, '개인정보 수집 및 이용 동의')}">
          <validator rules="required" name="개인정보 수집 및 이용 동의">
            <input
              id="agreePrivacy"
              v-model="agreeTerms.agreePrivacy"
              name="agreePrivacy"
              class="form-agree-input"
              type="checkbox"
              value=""
              @change="agreeTermsChange({ agreePrivacy: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreePrivacy">
              <em class="text-brand">(필수) </em><button @click="moveToPrivacy">개인정보 수집 및 이용 동의</button>
            </label>
          </validator>
        </div>
      </li>

      <li>
        <div class="term-head form-agree" :class="{ error: hasError(errors, '개인정보 제3자 제공 동의')}">
          <validator rules="required" name="개인정보 제3자 제공 동의">
            <input
              id="agreeThirdParty"
              v-model="agreeTerms.agreeThirdParty"
              name="agreeThirdParty"
              class="form-agree-input"
              type="checkbox"
              value=""
              @change="agreeTermsChange({ agreeThirdParty: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreeThirdParty">
              <em class="text-brand">(필수) </em><button @click="moveToThirdParty">개인정보 제3자 제공 동의</button>
            </label>
          </validator>
        </div>
      </li>

      <li v-if="isMonthlySubscribe">
        <div class="term-head form-agree" :class="{ error: hasError(errors, '구독형 이용 동의')}">
          <validator rules="required" name="구독형 이용 동의">
            <input
              id="agreeMonthlySubscribe"
              v-model="agreeTerms.agreeMonthlySubscribe"
              type="checkbox"
              value=""
              name="agreeMonthlySubscribe"
              class="form-agree-input"
              @change="agreeTermsChange({ agreeMonthlySubscribe: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreeMonthlySubscribe">
              <em class="text-brand">(필수) </em><button @click="moveToMonthlySubscribe">구독형 이용 동의</button>
            </label>
          </validator>
        </div>
      </li>

      <li v-if="!isShortTerm">
        <div class="term-head form-agree" :class="{ error: hasError(errors, '신용 정보 조회 동의')}">
          <validator rules="required" name="신용 정보 조회 동의">
            <input
              id="agreeCreditCheck"
              v-model="agreeTerms.agreeCreditCheck"
              type="checkbox"
              value=""
              name="agreeCreditCheck"
              class="form-agree-input"
              @change="agreeTermsChange({ agreeCreditCheck: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreeCreditCheck">
              <em class="text-brand">(필수) </em><button @click="moveToCreditCheck">신용 정보 조회 동의</button>
            </label>
          </validator>
        </div>
      </li>

      <li v-if="isPrepaidPayment">
        <div class="term-head form-agree" :class="{ error: hasError(errors, '선납금 동의')}">
          <validator rules="required" name="선납금 동의">
            <input
              id="agreePrepaidPayment"
              v-model="agreeTerms.agreePrepaidPayment"
              type="checkbox"
              value=""
              name="agreePrepaidPayment"
              class="form-agree-input"
              @change="agreeTermsChange({ agreePrepaidPayment: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreePrepaidPayment">
              <em class="text-brand">(필수) </em><button @click="moveToPrepaidPayment">선납금 동의</button>
            </label>
          </validator>
        </div>
      </li>

      <li v-if="isAvanteN">
        <div class="term-head form-agree" :class="{ error: hasError(errors, '난폭, 위험 운전 주의 차량 이용 동의')}">
          <validator rules="required" name="난폭, 위험 운전 주의 차량 이용 동의">
            <input
              id="agreeBewareRecklessDriving"
              v-model="agreeTerms.agreeBewareRecklessDriving"
              type="checkbox"
              value=""
              name="agreeBewareRecklessDriving"
              class="form-agree-input"
              @change="agreeTermsChange({ agreeBewareRecklessDriving: $event.target.checked })"
            >
            <label class="form-agree-label" for="agreeBewareRecklessDriving">
              <em class="text-brand">(필수) </em><button @click="moveToBewareRecklessDriving">난폭, 위험 운전 주의 차량 이용 동의</button>
            </label>
          </validator>
        </div>
      </li>
    </ul>

    <div v-if="!isShortTerm" class="content blue050">
      <small>
        다음 단계 선택 시 계약을 위한 신용 조회가 진행됩니다.<br>
      </small>
    </div>

    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full btn_outline"
          @click.prevent="cancel"
        >
          이전
        </button>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full"
          :disabled="!valid"
          @click.prevent="next"
        >
          다음
        </button>
      </vs-col>
    </vs-row>
  </validation-observer>
</template>

<script>
import config from 'config';
import { assign, mapValues, reduce, omit } from 'lodash';
import HeaderUtil from 'utils/header';
import OpenAppUtil from 'utils/openApp';
import DialogUtil from 'utils/dialog';
import * as amplitude from '@amplitude/analytics-browser';
import { isWebview } from 'utils/webview/isWebview';
import { closeWebView } from 'utils/webview/closeWebView';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';

export default {
  name: 'Step02',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isShortTerm: {
      type: Boolean,
      required: true,
    },
    isMonthlySubscribe: {
      type: Boolean,
      required: true,
    },
    isPrepaidPayment: {
      type: Boolean,
      required: true,
    },
    isAvanteN: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      planHomeUrl: config.planHome.baseURL,
      agreeAllTerms: false,
      agreeTerms: assign({
        agreeService: false,
        agreeCarSharing: false,
        agreePrivacy: false,
        agreeCreditCheck: false,
        agreeThirdParty: false,
        agreeMonthlySubscribe: false,
        agreePrepaidPayment: false,
        agreeBewareRecklessDriving: false,
      }, this.data.agreeTerms),
      isMonthlySubscribeCouponTime: false,
    };
  },
  computed: {
    valid() {
      return this.agreeAllTerms;
    },
    isElectric() {
      return this.data.carClassFuel === '전기';
    },
  },
  created() {
    const { regionGroup, carType, carTypeId, prepaidRate } = this.data;
    const args = {
      page_name: 'plan_contract_2_check_terms',
      event_label: regionGroup.id || '',
      event_category: document.title,
      page_url: document.URL,
      component_state: prepaidRate === 0 ? '' : `prepayments_${prepaidRate * 100}%`,
      component_type: carType.thumbnailTags.map(({ id }) => id).join(','),
      component_category: carType.carClassTag.id || '',
      component_id: carTypeId,
      service_type: carType.benefitTags.map(({ id }) => id).join(','),
    };
    this.agreeTermsChange();
    this.$gtag.event('view', args);
    amplitude.logEvent('view', args);
    const now = new Date();
    this.isMonthlySubscribeCouponTime = now >= new Date('2024-03-11:15:00:00');
  },
  methods: {
    next() {
      const { contractId } = this.data;
      const args = {
        page_name: 'plan_car_contract',
        event_category: document.title,
        page_url: document.URL,
        component_name: 'plan_check_terms_next_button',
        reservation_id: contractId,
      };
      this.$gtag.event('click', args);
      amplitude.logEvent('click', args);

      const agreeTerms = this.agreeTerms;
      this.$emit('next', { agreeTerms });
    },
    test() {
      postMessageToPlanHome('/mypage');
      closeWebView();
    },
    cancel() {
      DialogUtil.confirm('취소 하시겠습니까?', () => {
        if (isWebview()) {
          closeWebView();
          return;
        }
        this.$router.back();
      });
    },
    agreeAllTermsChange() {
      this.agreeTerms = mapValues(this.agreeTerms, () => this.agreeAllTerms);
    },
    agreeTermsChange(terms) {
      this.agreeTerms = assign({}, this.agreeTerms, terms);
      let agreeTerms = this.agreeTerms;
      if (this.isShortTerm) {
        agreeTerms = omit(agreeTerms, 'agreeCreditCheck');
      }
      if (!this.isMonthlySubscribe) {
        agreeTerms = omit(agreeTerms, 'agreeMonthlySubscribe');
      }
      if (!this.isPrepaidPayment) {
        agreeTerms = omit(agreeTerms, 'agreePrepaidPayment');
      }
      if (!this.isAvanteN) {
        agreeTerms = omit(agreeTerms, 'agreeBewareRecklessDriving');
      }
      this.agreeAllTerms = reduce(agreeTerms, (result, val) => (result && val), true);
    },

    moveToMonthlySubscribe() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-plan.zendesk.com/hc/ko/articles/19621254054041');
      } else {
        window.open('https://socar-plan.zendesk.com/hc/ko/articles/19621254054041', '_blank');
      }
    },
    moveToPrivacy() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-docs.zendesk.com/hc/ko/articles/360050811473');
      } else {
        window.open('https://socar-docs.zendesk.com/hc/ko/articles/360050811473', '_blank');
      }
    },
    moveToCreditCheck() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-docs.zendesk.com/hc/ko/articles/360050811413');
      } else {
        window.open('https://socar-docs.zendesk.com/hc/ko/articles/360050811413', '_blank');
      }
    },
    moveToThirdParty() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-docs.zendesk.com/hc/ko/articles/360050811513');
      } else {
        window.open('https://socar-docs.zendesk.com/hc/ko/articles/360050811513', '_blank');
      }
    },
    moveToCarSharing() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-docs.zendesk.com/hc/ko/articles/360048400294');
      } else {
        window.open('https://socar-docs.zendesk.com/hc/ko/articles/360048400294', '_blank');
      }
    },
    moveToPrepaidPayment() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-plan.zendesk.com/hc/ko/articles/22580728919961');
      } else {
        window.open('https://socar-plan.zendesk.com/hc/ko/articles/22580728919961', '_blank');
      }
    },
    moveToBewareRecklessDriving() {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal('https://socar-docs.zendesk.com/hc/ko/articles/27930489597593');
      } else {
        window.open('https://socar-docs.zendesk.com/hc/ko/articles/27930489597593', '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
